/**
 * Shared story-audio element.
 *
 * NavigationFooter renders the Player twice (mobile + desktop layouts), which
 * used to create two independent Audio objects for the same recording. The
 * karaoke highlighting needs a single source of truth for playback position,
 * so both Player instances and the highlight hook share one cached element.
 */
let cachedUrl: string | null = null
let cachedElement: HTMLAudioElement | null = null
let lastPlayingAt = 0

/** How long after pausing the karaoke visuals and tap-to-seek keep applying. */
export const KARAOKE_IDLE_MS = 10000

export function getStoryAudio(url: string): HTMLAudioElement {
  if (cachedUrl !== url || !cachedElement) {
    if (cachedElement) {
      cachedElement.pause()
    }
    cachedElement = new Audio(url)
    cachedUrl = url
    lastPlayingAt = 0
    const markPlaying = () => {
      if (cachedElement && !cachedElement.paused) lastPlayingAt = Date.now()
    }
    cachedElement.addEventListener('play', markPlaying)
    cachedElement.addEventListener('timeupdate', markPlaying)
  }
  return cachedElement
}

/**
 * True while the recording is playing, or paused for less than `withinMs`.
 * The karaoke visuals and tap-to-seek only apply during this window — once
 * the learner has stopped listening for a while, a tap on a word goes back
 * to being a plain dictionary tap.
 */
export function storyAudioActiveWithin(withinMs: number): boolean {
  if (!cachedElement) return false
  if (!cachedElement.paused && !cachedElement.ended) return true
  return lastPlayingAt > 0 && Date.now() - lastPlayingAt <= withinMs
}
